;
(function ($) {
  var dataKey = 'app.paymentAdjustment';
  var PaySteps = function PaySteps(element, options) {
    this.element = element;
    this.init(options);
  };
  PaySteps.prototype = {
    settings: {
      locale: 'en',
      dateFormat: 'DD/MM/YYYY',
      dateFormatFull: 'dddd Do MMMM YYYY',
      maximumInstalments: 999,
      minimumPaymentAmount: 5,
      pounds: {
        internationalCode: 'en-GB',
        style: 'currency',
        currencyCode: 'GBP'
      }
    },
    globals: {
      clearBalance: true,
      accountBalance: null,
      minimumInstalments: 1,
      maximumInstalments: 999,
      minimumPaymentAmount: 5,
      paymentAmount: null,
      partialPaymentAmount: null,
      instalments: 2,
      lastInstalment: 0,
      frequency: 'Monthly',
      startDate: null,
      endDate: null,
      isPlanExplorerJourney: false
    },
    attr: {
      spinner: 'data-form-spinner',
      'clearBalanceElement': 'ClearBalance',
      'paymentPlanTypeElement': 'PaymentPlanTypeId',
      'accountBalanceElement': 'AccountBalance',
      'isPlanExplorerJourneyElement': 'IsPlanExplorerJourney',
      'instalmentsElement': ''
    },
    classes: {},
    /**
    * Initialise the Payment viewlistener
    * @public
    * @constructor
    *
    * DEV NOTE: This has been added as a result of the 'Plan Explorer integration' work. This is needed as the plan explorer allows us to skip certain steps of the payment plan journey. However, skipping the initial
    * step can cause problems with the javascript as the viewlistener will not get initialised. As a result of this, we have added this method to allow us to initialise the viewlistener when the 'IsPlanExplorerJourney'
    * element is present on the page. This is not an ideal solution but it is the best one we can produce without doing a full rewrite of the payment process journey.
    * More info on this piece of work can be found in DevOps: https://devops.pragroup.eu/Europe/Dev/_workitems/edit/13559
    */
    initPaymentViewListener: function initPaymentViewListener() {
      var data = {
        paymentPlanType: $('#' + this.attr.paymentPlanTypeElement).val(),
        clearBalance: $('#' + this.attr.clearBalanceElement).val() === 'True',
        accountBalance: $('#' + this.attr.accountBalanceElement).val()
      };
      app.viewListeners = new app.views.payment();
      app.viewListeners.init(data);
      app.viewListeners.initStartDatePicker('#PaymentAdjustmentForm');
    },
    /**
    * Initialise Payment Steps
    * @public
    * @constructor
    * @param {string} options - Apply and extend options into init if needed.
    */
    init: function init(options) {
      var isPlanExplorerJourney = $('#' + this.attr.isPlanExplorerJourneyElement).val();
      var isForceReset = this.checkIfIsForceReset();
      if (isPlanExplorerJourney === "True") {
        this.globals.isPlanExplorerJourney = true;
        this.initPaymentViewListener();
      } else if (!isForceReset) {
        this.initPaymentViewListener();
      }
      $.extend(this.options, options);
      this.initialiseGlobals();
      var slider = $('[data-payment-range]')[0];
      if (slider) {
        var sliderOptions = $.extend(app.options.slider(), {
          range: {
            'min': this.globals.minimumInstalments,
            'max': this.globals.maximumInstalments
          },
          start: [this.globals.instalments]
        });
        noUiSlider.create(slider, sliderOptions);
        this.updatePaymentInstalmentsSlider();
      }
      this.initPaymentAmountValidation();
      this.initPaymentStartDateValidation();
      this.updatePaymentInstalmentsButtons();
      this.updatePaymentEndDate();
      this.updatePaymentSummary();
      this.initEventListeners();
    },
    checkIfIsForceReset: function checkIfIsForceReset() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var value = urlParams.get('forceReset');
      if (value === "false") {
        return false;
      }
      return true;
    },
    initialiseGlobals: function initialiseGlobals() {
      this.globals.maximumInstalments = this.settings.maximumInstalments;
      this.globals.clearBalance = app.viewListeners.cart.clearBalance;
      this.globals.accountBalance = app.viewListeners.cart.accountBalance;
      this.globals.minimumPaymentAmount = this.settings.minimumPaymentAmount;

      //get upper limit of instalments
      if (this.globals.clearBalance) {
        var maxInstalments = Math.ceil(this.globals.accountBalance / this.globals.minimumPaymentAmount);
        if (this.globals.maximumInstalments > maxInstalments) {
          this.globals.maximumInstalments = maxInstalments;
        }
      } else {
        var maxInstalments = Math.floor(this.globals.accountBalance / this.globals.minimumPaymentAmount);
        if (this.globals.maximumInstalments > maxInstalments) {
          this.globals.maximumInstalments = maxInstalments;
        }
      }

      //get lower limit of payment
      if (this.globals.clearBalance) {
        var deductedMaxInstalments = this.globals.maximumInstalments - 1;
        if (deductedMaxInstalments == 0) {
          deductedMaxInstalments = 1;
        }
        if (this.globals.accountBalance / this.globals.minimumPaymentAmount == this.globals.maximumInstalments) {
          this.globals.minimumPaymentAmount = Math.round(this.globals.accountBalance / this.globals.maximumInstalments * 100) / 100;
        } else if (this.globals.accountBalance / this.globals.minimumPaymentAmount > deductedMaxInstalments) {
          this.globals.minimumPaymentAmount = Math.ceil(this.globals.accountBalance / deductedMaxInstalments * 100) / 100;
        } else {
          this.globals.minimumPaymentAmount = Math.round(this.globals.accountBalance / this.globals.maximumInstalments * 100) / 100;
        }
        if (this.globals.minimumPaymentAmount < this.settings.minimumPaymentAmount) {
          this.globals.minimumPaymentAmount = this.settings.minimumPaymentAmount;
        }
        var adjustedMaxInstalments = Math.floor(this.globals.accountBalance / this.globals.minimumPaymentAmount) + 1;
        if (adjustedMaxInstalments < this.globals.maximumInstalments) {
          this.globals.maximumInstalments = adjustedMaxInstalments;
        }
      }

      //initialise the amount
      this.globals.paymentAmount = parseFloat($('[data-adjustment-amount]').val().replace(/\D/g, '')) / 100;
      this.globals.partialPaymentAmount = this.globals.paymentAmount;

      //initialise the instalments box
      this.globals.instalments = parseInt($('[data-adjustment-instalments]').val().replace(/\D/g, ''));

      //calculate last instalment
      if (this.globals.clearBalance) {
        var totalValueOfInstalments = Math.round(this.globals.paymentAmount * this.globals.instalments * 100) / 100;
        if (totalValueOfInstalments != this.globals.accountBalance) {
          totalValueOfInstalments = Math.round(this.globals.paymentAmount * (this.globals.instalments - 1) * 100) / 100;
          this.globals.lastInstalment = Math.round((this.globals.accountBalance - totalValueOfInstalments) * 100) / 100;
        } else {
          this.globals.lastInstalment = 0;
        }
      } else {
        totalValueOfInstalments = Math.round(this.globals.paymentAmount * this.globals.instalments * 100) / 100;
        this.globals.lastInstalment = Math.round((this.globals.accountBalance - totalValueOfInstalments) * 100) / 100;
      }

      //intialise frequency
      var frequency = this.globals.frequency;
      $('[data-payment-steps]').find('[data-payment-frequency]').each(function () {
        if ($(this).is(':checked')) {
          frequency = $(this).val();
        }
      });
      this.globals.frequency = frequency;
      this.updatePaymentFrequencyLabel();
    },
    initPaymentAmountValidation: function initPaymentAmountValidation() {
      var paymentAmountInput = $('[data-payment-amount]');
      if (paymentAmountInput.length < 1) {
        return;
      }
      var _this = this;
      if (!$.validator.methods.paymentAmountRequired) {
        $.validator.addMethod('paymentAmountRequired', function (paymentAmountValue, element) {
          if (!paymentAmountValue) {
            return false;
          }
          var paymentAmount = parseFloat(paymentAmountValue.replace(/£/g, '').replace(/,/g, ''));
          return !isNaN(paymentAmount);
        });
      }
      if (!$.validator.methods.minimumPaymentAmount) {
        $.validator.addMethod('minimumPaymentAmount', function (paymentAmountValue, element) {
          var paymentAmount = parseFloat(paymentAmountValue.replace(/£/g, '').replace(/,/g, ''));
          return paymentAmount >= _this.globals.minimumPaymentAmount;
        });
      }
      if (!$.validator.methods.maximumPaymentAmount) {
        $.validator.addMethod('maximumPaymentAmount', function (paymentAmountValue, element) {
          var paymentAmount = parseFloat(paymentAmountValue.replace(/£/g, '').replace(/,/g, ''));
          return paymentAmount <= _this.globals.accountBalance;
        });
      }
      $.validator.unobtrusive.parse(paymentAmountInput);
      var minimumPaymentAmount;
      if (_this.globals.minimumPaymentAmount === 5) {
        minimumPaymentAmount = _this.globals.minimumPaymentAmount + '.00';
      } else {
        minimumPaymentAmount = _this.globals.minimumPaymentAmount;
      }
      paymentAmountInput.rules('add', {
        paymentAmountRequired: true,
        minimumPaymentAmount: true,
        maxlength: 20,
        maximumPaymentAmount: true,
        messages: {
          paymentAmountRequired: "Your payment amount cannot be empty",
          minimumPaymentAmount: "A minimum payment of £" + minimumPaymentAmount + " is required",
          maxlength: "The payment amount must be less than 20 characters",
          maximumPaymentAmount: "The payment amount cannot exceed the account balance"
        }
      });
    },
    removePaymentAmountValidation: function removePaymentAmountValidation() {
      var paymentAmountInput = $('[data-payment-amount]');
      if (paymentAmountInput.length < 1) {
        return;
      }
      $.validator.unobtrusive.parse(paymentAmountInput);
      paymentAmountInput.rules('remove', 'paymentAmountRequired');
      paymentAmountInput.rules('remove', 'minimumPaymentAmount');
      paymentAmountInput.rules('remove', 'maxlength');
      paymentAmountInput.rules('remove', 'maximumPaymentAmount');
    },
    initPaymentStartDateValidation: function initPaymentStartDateValidation() {
      var paymentStartDateInput = $('[data-payment-startdate]');
      if (paymentStartDateInput.length < 1) {
        return;
      }
      $.validator.unobtrusive.parse(paymentStartDateInput);
      paymentStartDateInput.rules('add', {
        required: true,
        messages: {
          required: "Please select the start date for your payment plan."
        }
      });
    },
    removePaymentStartDateValidation: function removePaymentStartDateValidation() {
      var paymentStartDateInput = $('[data-payment-startdate]');
      if (paymentStartDateInput.length < 1) {
        return;
      }
      $.validator.unobtrusive.parse(paymentStartDateInput);
      paymentStartDateInput.rules('remove', 'required');
    },
    /**
     * Initialise Event Listeners
     * Listening for changes on Payment Amount, Instalments and Slider.
     * @public
     */

    initEventListeners: function initEventListeners() {
      var _this = this;
      var slider = $('[data-payment-range]')[0];
      if (slider) {
        slider.noUiSlider.on('slide', function () {
          _this.onPaymentInstalmentsSliderChange(slider);
          if (app.viewListeners.cart.paymentAmount) {
            var step = app.viewListeners.getPaymentStep(slider);
            var button = step.find('[data-payment-confirm]');
            button.addClass('btn--danger');
            button.html('Confirm Change');
          }
        });
      }
      $('[data-payment-amount]').on('keyup', function () {
        _this.onPaymentAmountChange();
      });
      $('[data-payment-instalments]').on('change', function () {
        _this.onPaymentInstalmentsChange();
      });
      $('[data-adjustment-add]').on('click', function (e) {
        _this.onPaymentInstalmentsAdd(e);
      });
      $('[data-adjustment-subtract]').on('click', function (e) {
        _this.onPaymentInstalmentsSubtract(e);
      });
      $('[data-payment-frequency]').on('change', function () {
        _this.onPaymentFrequencyChange();
      });
      $('[data-payment-startdate]').on('change', function () {
        _this.onPaymentStartDateChange();
      });
      $('[data-payment-method]').on('click', function (e) {
        _this.onPaymentMethodSelection(e);
      });
      $('[data-payment-confirm]').on('click', function (e) {
        _this.assessPaymentMethodAndInstalments(e);
      });
      $('[data-payment-previous]').on('click', function (e) {
        _this.removePaymentAmountValidation();
        _this.removePaymentStartDateValidation();
      });
    },
    onPaymentAmountChange: function onPaymentAmountChange() {
      var amount = parseFloat($('[data-adjustment-amount]').val().replace(/£/g, '').replace(/,/g, ''));
      this.globals.paymentAmount = amount;
      var isPaymentAmountValid = $('[data-adjustment-amount]').valid();
      if (isPaymentAmountValid) {
        $('[data-valmsg-for="PaymentAmountString"]').hide();
        this.updatePaymentAmount();
        this.updatePaymentInstalmentsButtons();
        this.updatePaymentInstalmentsSlider();
        this.updatePaymentFrequencyLabel();
        this.updatePaymentEndDate();
        this.updatePaymentSummary();
      } else {
        $('[data-valmsg-for="PaymentAmountString"]').show();
      }
    },
    onPaymentInstalmentsChange: function onPaymentInstalmentsChange() {
      var instalments = parseInt($('[data-adjustment-instalments]').val().replace(/\D/g, ''));
      if (isNaN(instalments)) {
        instalments = this.globals.instalments;
        this.updatePaymentInstalmentsInput(instalments);
      }
      this.updatePaymentInstalments(instalments);
      this.updatePaymentInstalmentsButtons();
      this.updatePaymentInstalmentsSlider();
      this.updatePaymentFrequencyLabel();
      this.updatePaymentEndDate();
      this.updatePaymentSummary();
    },
    onPaymentInstalmentsSliderChange: function onPaymentInstalmentsSliderChange(slider) {
      var instalments = parseFloat(slider.noUiSlider.get());
      if (instalments != this.globals.instalments) {
        this.updatePaymentInstalments(instalments);
        this.updatePaymentInstalmentsButtons();
        this.updatePaymentFrequencyLabel();
        this.updatePaymentEndDate();
        this.updatePaymentSummary();
      }
    },
    onPaymentInstalmentsAdd: function onPaymentInstalmentsAdd(e) {
      e.preventDefault();
      if (this.globals.instalments < this.globals.maximumInstalments) this.globals.instalments++;
      this.updatePaymentInstalments(this.globals.instalments);
      this.updatePaymentInstalmentsButtons();
      this.updatePaymentInstalmentsSlider();
      this.updatePaymentFrequencyLabel();
      this.updatePaymentEndDate();
      this.updatePaymentSummary();
    },
    onPaymentInstalmentsSubtract: function onPaymentInstalmentsSubtract(e) {
      e.preventDefault();
      if (this.globals.instalments > this.globals.minimumInstalments) this.globals.instalments--;
      this.updatePaymentInstalments(this.globals.instalments);
      this.updatePaymentInstalmentsButtons();
      this.updatePaymentInstalmentsSlider();
      this.updatePaymentFrequencyLabel();
      this.updatePaymentEndDate();
      this.updatePaymentSummary();
    },
    onPaymentFrequencyChange: function onPaymentFrequencyChange() {
      var frequency;
      $('[data-payment-steps]').find('[data-payment-frequency]').each(function () {
        if ($(this).is(':checked')) {
          frequency = $(this).val();
        }
      });
      this.globals.frequency = frequency;
      this.updatePaymentEndDate();
      this.updatePaymentSummary();
      if (frequency == "Weekly") {
        this.toggleWeeklyFrequencyMessage(true);
        this.togglePaymentMethodChangeMessage('frequency');
        this.updatePaymentMethodOption(false);
      } else {
        this.toggleWeeklyFrequencyMessage(false);
        this.togglePaymentMethodChangeMessage('frequency');
        this.updatePaymentMethodOption(true);
      }
    },
    onPaymentMethodSelection: function onPaymentMethodSelection(e) {
      var recurringPaymentByBank = 'RecurrentPaymentByBankAccount';
      var datepicker = $('body').find('[data-payment-startdate]');
      datepicker.val(null);
      this.globals.startDate = null;
      if ($(e.currentTarget).val() == recurringPaymentByBank) {
        $("[data-debit-card-submit]").hide();
        $("[data-direct-debit-submit]").show();
        $('[data-payment-method-date-message="DirectDebit"]').show();
      } else {
        $("[data-direct-debit-submit]").hide();
        $("[data-debit-card-submit]").show();
        $('[data-payment-method-date-message="DirectDebit"]').hide();
      }

      //disable forward payment journey navigation on payment method change
      var navigator = $('.payment-navigator');
      if (navigator.length > 0) {
        navigator.find('li').slice(2).each(function () {
          var button = $(this).find('button');
          button.removeClass("valid");
          button.removeClass("invalid");
          button.attr("disabled", "disabled");
        });
      }
      var diff = datepicker.val() - new Date();
      var days = Math.ceil(diff / (1000 * 3600 * 24));
      var elm = $('[data-payment-days]');
      if (days > 1) {
        elm.html('Your first payment will be made in <strong>' + days.toFixed() + ' days</strong>.');
      } else if (days === 1) {
        elm.html('Your first payment will be made in <strong>1 day</strong>.');
      } else {
        elm.html('');
      }
      this.updatePaymentEndDate();
      this.updatePaymentSummary();
      app.viewListeners.initStartDatePicker('#PaymentAdjustmentForm');
    },
    assessPaymentMethodAndInstalments: function assessPaymentMethodAndInstalments(e) {
      var form = document.forms[0];
      var elToUpdateId = $(document.forms[0]).attr('data-ajax-update');
      var offset;
      var paymentAdjustmentForm = $('#PaymentAdjustmentForm');
      $('[' + this.attr.spinner + ']').show();
      paymentAdjustmentForm.validate().settings.focusInvalid = false;
      paymentAdjustmentForm.validate();
      $('[' + this.attr.spinner + ']').hide();
      if ($(window).width() < 768) {
        offset = 115;
      } else if ($(window).width() >= 768 && $(window).width() < 992) {
        offset = 140;
      } else {
        offset = 170;
      }
      $('html, body').animate({
        scrollTop: $('body').offset().top + offset
      }, 500);
      if (this.globals.instalments === 1 && $('[data-payment-method]:checked').val() == "RecurrentPaymentByCard") {
        e.preventDefault();
        app.helpers.openModal("/common/paymentadjustment", "ajax");
        $('[' + this.attr.spinner + ']').hide();
      }
    },
    onPaymentStartDateChange: function onPaymentStartDateChange() {
      this.globals.startDate = $('[data-payment-startdate]').val();
      this.updatePaymentEndDate();
      this.updatePaymentSummary();
    },
    updatePaymentAmount: function updatePaymentAmount() {
      if (!this.globals.clearBalance) {
        this.globals.partialPaymentAmount = this.globals.paymentAmount;
      }

      //update instalment input
      if (this.globals.paymentAmount == this.globals.accountBalance) {
        this.globals.instalments = 1;
        this.globals.lastInstalment = 0;
      } else if (this.globals.clearBalance) {
        //main calculation for amount change
        this.globals.instalments = Math.ceil(this.globals.accountBalance / this.globals.paymentAmount);
        var totalValueOfInstalments = Math.round(this.globals.paymentAmount * this.globals.instalments * 100) / 100;
        if (totalValueOfInstalments != this.globals.accountBalance) {
          totalValueOfInstalments = Math.round(this.globals.paymentAmount * (this.globals.instalments - 1) * 100) / 100;
          this.globals.lastInstalment = Math.round((this.globals.accountBalance - totalValueOfInstalments) * 100) / 100;
        } else {
          this.globals.lastInstalment = 0;
        }
      } else {
        var softMaxInstalments = Math.floor(this.globals.accountBalance / this.globals.paymentAmount);
        if (this.globals.instalments > softMaxInstalments) this.globals.instalments = softMaxInstalments;
        totalValueOfInstalments = Math.round(this.globals.paymentAmount * this.globals.instalments * 100) / 100;
        this.globals.lastInstalment = Math.round((this.globals.accountBalance - totalValueOfInstalments) * 100) / 100;
      }
      this.updatePaymentInstalmentsInput(this.globals.instalments);
    },
    updatePaymentAmountInput: function updatePaymentAmountInput(amount) {
      var input = $('[data-adjustment-amount]');
      amount = amount.toLocaleString(this.settings.locale);
      var pence = amount.split('.').pop();
      if (amount.indexOf('.') > -1) {
        if (pence.length < 2) {
          amount = amount + '0';
        }
      } else {
        amount = amount + '.00';
      }
      input.val('£' + amount.toLocaleString(this.settings.locale));
      if (input.valid()) {
        $('[data-valmsg-for="PaymentAmountString"]').hide();
      } else {
        $('[data-valmsg-for="PaymentAmountString"]').show();
      }
    },
    updatePaymentInstalments: function updatePaymentInstalments(instalments) {
      //validate instalments
      if (this.globals.accountBalance < 10) {
        this.globals.minimumInstalments = 1;
        this.globals.maximumInstalments = 1;
        this.globals.instalments = this.globals.minimumInstalments;
      }
      if (instalments < this.globals.minimumInstalments) {
        this.globals.instalments = this.globals.minimumInstalments;
        this.updatePaymentInstalmentsInput(this.globals.instalments);
      } else if (instalments > this.globals.maximumInstalments) {
        this.globals.instalments = this.globals.maximumInstalments;
        this.updatePaymentInstalmentsInput(this.globals.instalments);
      } else {
        this.globals.instalments = instalments;
      }

      //update payment amount
      if (this.globals.clearBalance) {
        if (this.globals.instalments == this.globals.minimumInstalments) {
          this.globals.paymentAmount = this.globals.accountBalance;
          this.globals.lastInstalment = 0;
        } else if (this.globals.instalments == this.globals.maximumInstalments) {
          this.globals.paymentAmount = this.globals.minimumPaymentAmount;
          var totalValueOfInstalments = Math.round(this.globals.paymentAmount * this.globals.instalments * 100) / 100;
          if (totalValueOfInstalments != this.globals.accountBalance) {
            //recalculate the new total value of the instalments - 1
            totalValueOfInstalments = Math.round(this.globals.paymentAmount * (this.globals.instalments - 1) * 100) / 100;

            //this occurs if we remove one instalment and the total sum of the instlaments is the same as the balance
            if (totalValueOfInstalments == this.globals.accountBalance) {
              this.globals.paymentAmount -= 0.01;
              totalValueOfInstalments = Math.round(this.globals.paymentAmount * (this.globals.instalments - 1) * 100) / 100;
            }
            this.globals.lastInstalment = Math.round((this.globals.accountBalance - totalValueOfInstalments) * 100) / 100;
          } else {
            this.globals.lastInstalment = 0;
          }
        } else {
          this.globals.paymentAmount = Math.round(this.globals.accountBalance / this.globals.instalments * 100) / 100;
          var totalValueOfInstalments = Math.round(this.globals.paymentAmount * this.globals.instalments * 100) / 100;
          if (totalValueOfInstalments != this.globals.accountBalance) {
            //To get values most evenly distributed between the recurring and last instalment we can adjust balance to an evenly divisable about and then
            //distribute that amount to get each instalment value. We then subtract the added amount for even distribution from the last instalment to get
            //back to totalling original value

            // calculate remainder when balance equally distributed
            var remainingPence = this.globals.accountBalance * 100 % instalments;
            // calculated total that would ditribute evenly without remainder
            var adjustedTotalBalancePenceValue = this.globals.accountBalance * 100 + (this.globals.instalments - remainingPence);
            // calculate what the value would be divided evenly
            var ajustedPaymentPerInstalment = Math.floor(adjustedTotalBalancePenceValue / this.globals.instalments);
            this.globals.paymentAmount = ajustedPaymentPerInstalment / 100;

            //calcualte last instalment value minus the added value used for adusted total
            this.globals.lastInstalment = (ajustedPaymentPerInstalment + (remainingPence - this.globals.instalments)) / 100;
          } else {
            this.globals.lastInstalment = 0;
          }
        }
      } else {
        var tempMaxAmount = Math.floor(this.globals.accountBalance / this.globals.instalments * 100) / 100;
        if (tempMaxAmount < this.globals.minimumPaymentAmount) {
          tempMaxAmount = this.globals.minimumPaymentAmount;
        }
        if (tempMaxAmount < this.globals.partialPaymentAmount) {
          this.globals.paymentAmount = tempMaxAmount;
        } else {
          this.globals.paymentAmount = this.globals.partialPaymentAmount;
        }
        var totalValueOfInstalments = Math.round(this.globals.paymentAmount * this.globals.instalments * 100) / 100;
        this.globals.lastInstalment = Math.round((this.globals.accountBalance - totalValueOfInstalments) * 100) / 100;
      }
      this.updatePaymentAmountInput(this.globals.paymentAmount);
      this.updatePaymentInstalmentsInput(this.globals.instalments);
      if (this.globals.instalments == 1) {
        this.toggleOneInstalmentMessage(true);
        this.togglePaymentMethodChangeMessage('instalments');
        this.updatePaymentMethodOption(false);
      } else {
        this.toggleOneInstalmentMessage(false);
        this.togglePaymentMethodChangeMessage('instalments');
        this.updatePaymentMethodOption(true);
      }
    },
    updatePaymentInstalmentsInput: function updatePaymentInstalmentsInput(instalments) {
      var input = $('[data-adjustment-instalments]');
      input.val(instalments);
    },
    updatePaymentInstalmentsSlider: function updatePaymentInstalmentsSlider() {
      var slider = $('[data-payment-range]')[0];
      if (slider) {
        var scrollPadding = 0;
        var options = $.extend(app.options.slider(), {
          padding: [0, scrollPadding],
          range: {
            'min': this.globals.minimumInstalments,
            'max': this.globals.maximumInstalments
          },
          animate: true,
          animationDuration: 300,
          start: [this.globals.instalments]
        });
        slider.noUiSlider.set(this.globals.instalments);
        slider.noUiSlider.updateOptions(options);
      }
    },
    updatePaymentInstalmentsButtons: function updatePaymentInstalmentsButtons() {
      var addBtn = $('[data-adjustment-add]');
      var subtractBtn = $('[data-adjustment-subtract]');
      addBtn.prop('disabled', false);
      addBtn.addClass('fa-plus');
      addBtn.removeClass('disabled fa-times');
      subtractBtn.prop('disabled', false);
      subtractBtn.addClass('fa-minus');
      subtractBtn.removeClass('disabled fa-times');
      if (this.globals.instalments == 1) {
        subtractBtn.prop('disabled', true);
        subtractBtn.removeClass('fa-minus');
        subtractBtn.addClass('disabled fa-times');
      } else if (this.globals.instalments == this.globals.maximumInstalments) {
        addBtn.prop('disabled', true);
        addBtn.removeClass('fa-plus');
        addBtn.addClass('disabled fa-times');
      }
    },
    updatePaymentFrequencyLabel: function updatePaymentFrequencyLabel() {
      var elm = $('#data-payment-frequency-label');
      if (elm.length > 0) {
        if (this.globals.instalments == 1) {
          elm.hide();
        } else {
          elm.show();
        }
      }
    },
    updatePaymentMethodOption: function updatePaymentMethodOption(enableDirectDebit) {
      var frequency = $('[data-payment-frequency]:checked').val();
      var instalments = $('[data-payment-instalments]').val();
      if (!enableDirectDebit && $('[data-payment-method]:checked').val() == "RecurrentPaymentByBankAccount") {
        $('[data-payment-method = "RecurrentPaymentByBankAccount"]').attr('disabled', true);
        $('[data-payment-method = "RecurrentPaymentByCard"]').click();
      } else if (frequency != 'Weekly' && instalments != 1) {
        $('[data-payment-method = "RecurrentPaymentByBankAccount"]').removeAttr('disabled');
      } else {
        $('[data-payment-method = "RecurrentPaymentByBankAccount"]').attr('disabled', true);
      }
    },
    updatePaymentEndDate: function updatePaymentEndDate() {
      var instalments = this.globals.instalments;
      if (this.globals.instalments == 1) {
        this.globals.endDate = moment(this.globals.startDate, this.settings.dateFormat);
      } else {
        var startDate = moment(this.globals.startDate, this.settings.dateFormat);
        switch (this.globals.frequency) {
          case 'Weekly':
            this.globals.endDate = startDate.add(instalments - 1, 'weeks');
            break;
          case 'Fortnightly':
            this.globals.endDate = startDate.add(14 * (instalments - 1), 'days');
            break;
          case 'FourWeeks':
            this.globals.endDate = startDate.add(28 * (instalments - 1), 'days');
            break;
          case 'Monthly':
            this.globals.endDate = startDate.add(instalments - 1, 'months');
            break;
          default:
            this.globals.endDate = this.globals.startDate;
            console.error('Unknown payment frequency provided.');
        }
      }
    },
    updatePaymentSummary: function updatePaymentSummary() {
      var remainingContainer = $('[data-adjustment-summary="lastpayment"]');
      var summaryAmount = '£' + this.globals.paymentAmount.toLocaleString(this.settings.locale);
      var instalments = this.globals.instalments;
      var template;
      var pence;
      if (summaryAmount.indexOf('.') > -1) {
        pence = summaryAmount.split('.').pop();
        if (pence.length < 2) {
          summaryAmount = summaryAmount + '0';
        }
      } else {
        summaryAmount = summaryAmount + '.00';
      }
      var summaryAmmount = $('[data-adjustment-summary="amount"]');
      var summaryInstalments = $('[data-adjustment-summary="instalments"]');
      if (this.globals.clearBalance) {
        if (this.globals.lastInstalment > 0) {
          template = '<ul><li>and</li><li class="divided"><strong>1</strong> payment of <strong><span></span></strong></li></ul>';
          if (remainingContainer.is(':empty')) {
            remainingContainer.html(template);
          }
          remainingContainer.find('span').html('£' + this.globals.lastInstalment.toFixed(2));
          if (this.globals.clearBalance) {
            instalments--;
          }
        } else {
          remainingContainer.html('');
          if (this.globals.instalments < 2) {
            remainingContainer.html('');
            summaryAmmount.html(summaryAmount);
          }
        }
      } else {
        if (this.globals.lastInstalment > 0) {
          var summaryRemaining = '£' + this.globals.lastInstalment.toLocaleString(this.settings.locale);
          template = '<ul><li>with a remaining balance</li><li class="divided">of <strong><span></span></strong></li></ul>';
          if (summaryRemaining.indexOf('.') > -1) {
            pence = summaryRemaining.split('.').pop();
            if (pence.length < 1) {
              summaryRemaining = summaryRemaining + '0';
            } else if (pence.length < 2) {
              summaryRemaining = summaryRemaining + '0';
            }
          } else {
            summaryRemaining = summaryRemaining + '.00';
          }
          if (remainingContainer.is(':empty')) {
            remainingContainer.html(template);
          }
          remainingContainer.find('span').html(summaryRemaining);
          if (this.globals.clearBalance) {
            instalments--;
          }
        } else {
          remainingContainer.html('');
        }
      }
      summaryInstalments.html(instalments);
      summaryAmmount.html(summaryAmount);
      $('[data-adjustment-summary="date"]').html(this.globals.endDate.format(this.settings.dateFormat));
      if (this.globals.startDate != null) {
        $('[data-adjustment-summary="lastpaymentdate"]').show();
      } else {
        $('[data-adjustment-summary="lastpaymentdate"]').hide();
      }
      var isValid = this.validatePaymentPlan();
      this.showInstalmentsExceededError(!isValid);
      this.toggleConfirmButtons(isValid);
    },
    toggleOneInstalmentMessage: function toggleOneInstalmentMessage(displayMessage) {
      if (displayMessage) {
        $('[data-payment-instalments-message]').show();
      } else {
        $('[data-payment-instalments-message]').hide();
      }
    },
    toggleWeeklyFrequencyMessage: function toggleWeeklyFrequencyMessage(displayMessage) {
      if (displayMessage) {
        $('[data-payment-frequency-message="Weekly"]').show();
      } else {
        $('[data-payment-frequency-message="Weekly"]').hide();
      }
    },
    togglePaymentMethodChangeMessage: function togglePaymentMethodChangeMessage(sourceArea) {
      var paymentMethod = $('[data-payment-method]:checked').val();
      var frequency = $('[data-payment-frequency]:checked').val();
      var instalments = $('[data-payment-instalments]').val();
      if (paymentMethod == 'RecurrentPaymentByBankAccount') {
        if (sourceArea == 'frequency') {
          if (frequency == 'Weekly') {
            $('[data-payment-method-frequency-message="DirectDebit"]').show();
          }
        }
        if (sourceArea == 'instalments') {
          if (instalments == 1) {
            $('[data-payment-method-instalments-message="DirectDebit"]').show();
          }
        }
      } else {
        if (sourceArea == 'frequency') {
          $('[data-payment-method-frequency-message="DirectDebit"]').hide();
        }
        if (sourceArea == 'instalments') {
          $('[data-payment-method-instalments-message="DirectDebit"]').hide();
        }
      }
    },
    validatePaymentPlan: function validatePaymentPlan() {
      if (this.globals.clearBalance && this.globals.instalments > this.globals.maximumInstalments) {
        return false;
      }
      return true;
    },
    showInstalmentsExceededError: function showInstalmentsExceededError(show) {
      var errorContainer = $('[data-payment-instalments-exceeded-error]');
      if (show) {
        errorContainer.show();
      } else {
        errorContainer.hide();
      }
    },
    toggleConfirmButtons: function toggleConfirmButtons(enabled) {
      var buttons = $('[data-payment-confirm], [data-direct-debit-submit], [data-debit-card-submit]');
      if (enabled) {
        buttons.prop('disabled', false);
      } else {
        buttons.prop('disabled', true);
      }
    }
  };

  /**
   * Global callback function which by default all [data-payment-adjustment] triggers this plugin.
   * @method $.fn.app_paymentAdjustment()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_paymentAdjustment();
   */

  $.fn.app_paymentAdjustment = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof PaySteps) {
      plugin.init();
    } else {
      plugin = new PaySteps(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);